import { Button, message } from "antd";
import React, { useEffect, useState, useMemo } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { useDispatch, useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import BasicLayout from "../../../components/BasicLayout";
import ButtonAsLink from "../../../components/common/ButtonAsLink";
import FallBack from "../../../components/common/FallBack/FallBack";
import Tables from "../../../components/common/Table/Table";
import { useDeleteAction } from "../../../components/Hooks/useDeleteAction";
import useExportCsv from "../../../components/Hooks/useExportCsv";
import useTableSearch from "../../../components/Hooks/useTableSearch";
import { getGallery, softDeleteSingleGallery } from "../../../store/actions/gallery/gallery.action";
import { DeleteModel } from "../../../utils/DeleteModel";
import { formatFileName } from "../../../utils/helper";

const Index = ({ accessLevel }) => {
	const [getColumnSearchProps] = useTableSearch();
	const dispatch = useDispatch();
	const [exportToCSV] = useExportCsv();
	const { deleteData } = useDeleteAction();
	const [deleteId, setDeleteId] = useState(undefined);
	const [isModalVisible, setIsModalVisible] = useState(false);
	const galleries = useSelector((state) => state.gallery.galleries);

	const admin = useSelector((state) => state.admin.admin || []);

	const permissionArr = useMemo(() => {
		if (admin && admin.template) {
			const { permissions } = admin.template;
			return permissions;
		} else if (admin && admin.accessLevel === "superAdmin") {
			return "all";
		}
		return [];
	}, [admin]);

	useEffect(() => {
		dispatch(getGallery());
	}, [dispatch]);

	let dataSource = [];
	if (galleries.length > 0) {
		dataSource = galleries.sort(function (a, b) {
			return new Date(b.updatedAt) - new Date(a.updatedAt);
		});
		dataSource = dataSource.map((row) => ({
			...row,
			createdAt: new Date(row.createdAt).toLocaleString(),
			submissionName: row?.gallerySubmission ? (
				<NavLink to={`/gallery/submissions/${row?.gallerySubmission?.id}`}>
					{row?.gallerySubmission?.name}
				</NavLink>
			) : (
				"Added by admin"
			),
			key: row.id,
		}));
	}

	async function confirm(id, reason) {
		await deleteData(id, reason, softDeleteSingleGallery, setIsModalVisible);
	}

	const columns = [
		{
			title: "Id",
			dataIndex: "id",
			key: "id",
		},
		{
			title: "Name",
			dataIndex: "name",
			key: "name",
			...getColumnSearchProps("name"),
		},
		{
			title: "Gallery Submission Name",
			dataIndex: "submissionName",
			key: "submissionName",
			...getColumnSearchProps("submissionName"),
		},
		{
			title: "Category",
			dataIndex: "category",
			key: "category",
			...getColumnSearchProps("category"),
		},
		{
			title: "Type",
			dataIndex: "type",
			key: "type",
			...getColumnSearchProps("type"),
		},
		{
			title: "Action",
			key: "action",
			render: (_text, record) => (
				<DeleteModel
					record={record}
					confirm={confirm}
					setIsModalVisible={setIsModalVisible}
					isModalVisible={isModalVisible}
					cancelMessage="Gallery Removing has been cancelled"
					linkUrl={`/gallery/added`}
					placeholder="Please enter reason to delete gallery"
					deleteId={deleteId}
					setDeleteId={setDeleteId}
					update={
						permissionArr === "all"
							? "true"
							: permissionArr?.gallery?.added.filter((item) => item === "update")?.length > 0
							? "true"
							: false
					}
					isdelete={
						permissionArr === "all"
							? "true"
							: permissionArr?.gallery?.added.filter((item) => item === "delete")?.length > 0
							? "true"
							: false
					}
					view={
						permissionArr === "all"
							? "true"
							: permissionArr?.gallery?.added.filter((item) => item === "read")?.length > 0
							? "true"
							: false
					}
				/>
			),
		},
	];

	const fileName = formatFileName("galleries", "xlsx",admin);
	let downloadData = galleries.map((data) => {
		return Object.assign({}, data, {
			gallerySubmission: data.gallerySubmission ? data.gallerySubmission.title : "",
		});
	});

	const handleError = (error) => {
		message.error(error.message);
	};
	return (
		<BasicLayout accessLevel={accessLevel}>
			<ErrorBoundary FallbackComponent={FallBack} onError={handleError}>
				<div className="button-style-to-right">
					{permissionArr === "all" ? (
						<Button className="download-btn" onClick={(e) => exportToCSV(downloadData, fileName)}>
							Export
						</Button>
					) : permissionArr?.gallery?.added?.filter((item) => item === "export")?.length > 0 &&
					  downloadData?.length !== 0 ? (
						<Button className="download-btn" onClick={(e) => exportToCSV(downloadData, fileName)}>
							Export
						</Button>
					) : null}

					{permissionArr === "all" ? (
						<ButtonAsLink text="Add New Media" link="/gallery/add" />
					) : permissionArr?.gallery?.added?.filter((item) => item === "write")?.length > 0 ? (
						<ButtonAsLink text="Add New Media" link="/gallery/add" />
					) : null}
				</div>
				<Tables
					dataSource={dataSource}
					columns={columns}
					footerText={`Total Gallery media added: ${galleries.length}`}
				/>
			</ErrorBoundary>
		</BasicLayout>
	);
};

export default Index;
